import React, { useState, useContext, useEffect } from "react";
import Notifications, { notify } from "react-notify-toast";
import Master from "../../utils/Master";
import { useNavigate } from "react-router-dom";
import "./createandgen.css";
import "reactjs-popup/dist/index.css";
import Textgen from "../../elements/textgen/Textgen";
import Text from "../../elements/text/Text";
import * as constants from "../../constants/Constants";
import Check from "../../elements/check/Check";
// import axios from "axios";
import axios from "../../api/axios";
import "react-datepicker/dist/react-datepicker.css";
import Label from "../../elements/Label/Label";
import Radio from "../../elements/radio/Radio";
import Select from "react-select";
import Certificatemini from "../certificatemini/Certificatemini";
import Studentupload from "../studentupload/Studentupload";
import Csvdata from "../csvdata/Csvdata";
import Button from "../../elements/button/Button";
import Textarea from "../../elements/textarea/Textarea";
import Textareagen from "../../elements/textarea/Textareagen";
import Rte from "../Rte/Rte";
import Rtecourse from "../Rte/Rtecourse";
import Cicons from "../Cicons/Cicons";
import { Button as MuiButton } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const Createandgen = (props) => {
  const navigate = useNavigate();
  const {
    selectedmenu,
    setselectedmenu,
    certificatetitle,
    setcertificatetitle,
    certificatedesc,
    setcertificatedesc,
    issuedate,
    setissuedate,
    setprogram,
    program,
    grouplist,
    setgrouplist,
    selectedgroupobject,
    setselectedgroupobject,
    certificatesubtitle,
    setcertificatesubtitle,
    csvfile,
    saveandcontinue,
    setsaveandcontinue,
    showcsvdata,
    candidatename,
    setcandidatename,
    secertificateicons,
    desccoursename,
    setdesccoursename,
    emailhtml,
    setemailhtml,
    certificateiconsshow,
    setcertificateiconsshow,
    certificatepostsubtitle,
    setcertificatepostsubtitle,
    aboutcourse,
    setaboutcourse,
    clear,
  } = useContext(Master);

  const [certificatedate, setcertificatedate] = useState("");
  const [courses, setcourses] = useState([]);
  const [courseOptions, setcourseOptions] = useState([]);

  const [issueMode, setIssueMode] = useState("multiple"); // "single" | "multiple"
  const [singleStudent, setSingleStudent] = useState({
    name: "",
    email: "",
    phone: "",
  });

  // handling single student input change
  function handleSingleInput(e) {
    const { name, value } = e.target;
    setSingleStudent({ ...singleStudent, [name]: value });
  }

  //for date
  const today = new Date();
  const formattedToday = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const [dateValue, setdateValue] = useState(today.toISOString().split("T")[0]);

  useEffect(() => {
    if (!dateValue) {
      setdateValue(formattedToday);
      setissuedate(dateValue);
      setcertificatedate(issuedate);
    }
  }, [dateValue, setdateValue, setcertificatedate, formattedToday]);
  setissuedate(dateValue);

  useEffect(() => {
    // setselectedgroupobject({label:"",value:0})
    setcertificatetitle("CERTIFICATE");
    setcertificatesubtitle("Of Completion");
    setcertificatepostsubtitle("THIS CERTIFICATE IS PRESENTED TO");
    setcertificatedesc(
      "For successfully completing the training in $$ at Gradious Technologies (P) Ltd."
    );
    // setdesccoursename("Javascript Fullstack Developer");
    setselectedmenu(selectedmenu);
    setcertificateiconsshow(false);
    if (certificatedesc.length == "") {
      document.getElementById("gen-coursedesc-input").style.display = "none";
      document.getElementById("gen-coursedesc-display").innerHTML =
        "Enter description: use $$ in place of course name";
    } else {
      document.getElementById("gen-coursedesc-display").innerHTML =
        certificatedesc.replace(
          "$$",
          `<span class='replacewithgroupname'>` + desccoursename + `</span>`
        );
    }

    axios
      .get(`/group/selectgroup`)
      .then((response) => {
        setgrouplist(response.data);
        document.getElementById("gen-coursedesc-input").style.display = "none";
      })
      .catch((error) => {
        console.error("API call error:", error);
      });
  }, []);

  const handleUploadUserfile = () => {
    const form = new FormData();
    // if()

    form.append("csv", csvfile);
    form.append(
      "groupid",
      typeof selectedgroupobject == "undefined"
        ? null
        : selectedgroupobject.value
    );
    form.append(
      "groupname",
      typeof selectedgroupobject == "undefined"
        ? null
        : selectedgroupobject.label
    );
    form.append("program", program.value);
    form.append("desccoursename", desccoursename);
    form.append("title", certificatetitle);
    form.append("subtitle", certificatesubtitle);
    form.append("postsubtitle", certificatepostsubtitle);
    form.append("description", certificatedesc);
    form.append("issuedate", dateValue);
    form.append("emailhtml", emailhtml);
    form.append("showicons", "1");
    form.append("about", aboutcourse);

    axios
      .post("certificate/generate", form, {
        mode: "no-cors",
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((response) => {
        let myColor = { background: "#0E1717", text: "#FFFFFF" };
        notify.show(" Certificates Generated!", "success", 5000, myColor);
        clear();
        setcourseOptions([]);
        setTimeout(() => {
          navigate("/issuedcertificates", { replace: true });
        }, 3000);
      })
      .catch((error) => {
        let myColor = { background: "#FF0000", text: "#FFFFFF" };
        notify.show(
          "Email Server Error, Click Add and Issue Certificate Again! ",
          "error",
          5000,
          myColor
        );
      });
  };

  //getting courses
  useEffect(() => {
    axios
      .get(`courses`)
      .then((response) => {
        setcourses(response.data); // save API response

        // Transform data for react-select
        const courseOption = response.data.result.map((course) => ({
          value: course.id,
          label: course.coursename,
          about: course.about,
          icongroupid: course.icongroupid,
          name: course.name,
        }));

        setcourseOptions(courseOption); // update courseOptions state
      })
      .catch((error) => {
        console.error("API call error:", error);
      });
  }, []);

  const onDateChange = (event) => {
    let day = new Date(event.target.value).getDate();
    let mon = new Date(event.target.value).getMonth();
    mon = mon + 1;
    if ((mon + "").length == 1) {
      mon = "0" + mon;
    }
    if ((day + "").length == 1) {
      day = "0" + day;
    }
    let year = new Date(event.target.value).getFullYear();
    let finaldate = day + "/" + mon + "/" + year;
    setcertificatedate(finaldate);
    setdateValue(event.target.value);
    setissuedate(event.target.value);
  };

  useEffect(() => {
    if (certificatedesc.length == "") {
      document.getElementById("gen-coursedesc-display").innerHTML =
        "Enter description: use $$ in place of course name";
    } else {
      document.getElementById("gen-coursedesc-display").innerHTML =
        certificatedesc.replace(
          "$$",
          `<span class='replacewithgroupname'>` + desccoursename + `</span>`
        );
    }
  }, [certificatedesc, desccoursename]);

  function handlesaveandcontinue(value) {
    if (
      certificatetitle == "" ||
      certificatedesc == "" ||
      certificatesubtitle == "" ||
      issuedate == "" ||
      program == "" ||
      aboutcourse == ""
    ) {
      let myColor = { background: "#FF0000", text: "#FFFFFF" };
      notify.show("Enter all fields!", "error", 5000, myColor);
    } else {
      setsaveandcontinue(value);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 500);
    }
  }

  useEffect(() => {
    if (!selectedgroupobject?.value) return;
    axios
      .get(`icon/selectedgroupicons/` + selectedgroupobject?.value)
      .then((response) => {
        secertificateicons(response.data.result[0].icon_list);
      })
      .catch((error) => {
        console.error("API call error:", error);
      });
  }, [selectedgroupobject]);

  function changeshowcertificateicons() {
    setcertificateiconsshow(!certificateiconsshow);
  }

  const options = [
    { value: "COE", label: "COE" },
    { value: "Workshop", label: "Workshop" },
    { value: "Bootcamp", label: "Bootcamp" },
    { value: "Internal Trainee", label: "Internal Trainee" },
  ];

  function descriptiveinputfocus() {
    document.getElementById("gen-coursedesc-display").style.display = "none";
    document.getElementById("gen-coursedesc-input").style.display = "block";
  }

  function descriptiveinputblur() {
    document.getElementById("gen-coursedesc-display").style.display = "block";
    document.getElementById("gen-coursedesc-input").style.display = "none";
  }

  const handleUploadSingleStudent = () => {
    if (!singleStudent.name || !singleStudent.email || !singleStudent.phone) {
      let myColor = { background: "#FF0000", text: "#FFFFFF" };
      notify.show("Please enter all student details!", "error", 5000, myColor);
      return;
    }

    const form = new FormData();
    form.append("name", singleStudent.name);
    form.append("email", singleStudent.email);
    form.append("phone", singleStudent.phone);
    form.append("groupid", selectedgroupobject?.value || "");
    form.append("groupname", selectedgroupobject?.label || "");
    form.append("program", program.value);
    form.append("desccoursename", desccoursename);
    form.append("title", certificatetitle);
    form.append("subtitle", certificatesubtitle);
    form.append("postsubtitle", certificatepostsubtitle);
    form.append("description", certificatedesc);
    form.append("issuedate", dateValue);
    form.append("emailhtml", emailhtml);
    form.append("showicons", "1");
    form.append("about", aboutcourse);

    axios
      .post("certificate/generate-single", form, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then((response) => {
        let myColor = { background: "#0E1717", text: "#FFFFFF" };
        notify.show(
          "Certificate generated successfully!",
          "success",
          5000,
          myColor
        );
        clear();
        setTimeout(
          () => navigate("/issuedcertificates", { replace: true }),
          3000
        );
      })
      .catch((error) => {
        console.error("Error generating single certificate:", error);
        let myColor = { background: "#FF0000", text: "#FFFFFF" };
        notify.show(
          "Error issuing certificate. Try again.",
          "error",
          5000,
          myColor
        );
      });
  };

  return (
    <>
      <Notifications />
      <div className="createandgen">
        <div className="details">
          <div className="gen-coursesummary">
            <div className="gen-left-coursename">
              {desccoursename + "  Course"}
            </div>
            <div className="gen-left-completedby">
              {"Completed by  " + candidatename}
            </div>
            <div className="gen-left-issuedon">
              <div className="gen-left-issuedon-label">Issued on:&nbsp;</div>
              <div className="gen-left-issuedon-value">
                {certificatedate || formattedToday}
              </div>
            </div>
            <div className="gen-left-certificateid">
              <div className="gen-left-certificateid-label">
                Certificate ID:&nbsp;
              </div>
              {program == "" && (
                <div className="gen-left-certificateid-value">
                  {"select program and date"}
                </div>
              )}
              {program != "" && dateValue != "" && (
                <div className="gen-left-certificateid-value">
                  {program > 0
                    ? "select program"
                    : program.value[0] + dateValue?.substring(2, 4) + 12345}
                </div>
              )}
            </div>
          </div>
          <div className="course-description-label">
            {" "}
            <h5>Course Description:</h5>
          </div>
          <div className="course-description-rte">
            <Rtecourse
              initialValue={aboutcourse}
              onChange={(html) => setaboutcourse(html)}
            />
          </div>
        </div>

        <div className="gen-certificatemini-wrapper">
          <Certificatemini />

          <div className="gen-title">
            <Textgen
              label={"Certificate title"}
              update={setcertificatetitle}
              value={certificatetitle}
              required={true}
              name={"certificatetitle"}
              regx={constants.regx.alphabits.name}
              errortext={"Enter only alphabits"}
            />
          </div>

          <div className="gen-subtitle">
            <Textgen
              label={"Certificate subtitle"}
              update={setcertificatesubtitle}
              value={certificatesubtitle}
              required={true}
              name={"certificatesubtitle"}
              regx={constants.regx.alphabits.name}
              errortext={"Enter only alphabits"}
            />
          </div>

          <div className="gen-postsubtitle">
            <Textgen
              label={"Certificate postsubtitle"}
              update={setcertificatepostsubtitle}
              value={certificatepostsubtitle}
              required={true}
              name={"certificatesubtitle"}
              regx={constants.regx.alphabits.name}
              errortext={"Enter only alphabits"}
            />
          </div>
          <div className="gen-candidatename">
            <Textgen
              label={"Candidate Name"}
              update={setcandidatename}
              value={candidatename}
              required={true}
              name={"candidatename"}
              regx={constants.regx.alphabits.name}
              errortext={"Enter only alphabits"}
            />
          </div>

          <div
            className="gen-coursedesc"
            onMouseEnter={() => {
              descriptiveinputfocus();
            }}
            onMouseLeave={() => {
              descriptiveinputblur();
            }}
          >
            <div id="gen-coursedesc-input">
              <Textareagen
                placeholder={
                  "Enter description: use $$ in place of course name"
                }
                update={setcertificatedesc}
                value={certificatedesc}
                required={true}
                name={"course desc"}
                label={"Enter description: use $$ in place of course name"}
                errortext={"Enter only alphabits"}
              />
            </div>
            <div
              id="gen-coursedesc-display"
              onFocus={() => {
                descriptiveinputblur();
              }}
              onMouseEnter={() => {
                descriptiveinputfocus();
              }}
            ></div>
          </div>

          <div className="gen-issuedate">
            {"Issued on: " + (certificatedate || formattedToday)}
          </div>

          {program != "" && dateValue != "" && (
            <div className="gen-certificateid">
              Certificate ID:&nbsp;
              {program.value[0] + dateValue?.substring(2, 4) + 12345}
            </div>
          )}
          {<Cicons class={"certificationminicicons"} />}
          <div className="course-details-label"> </div>
          <div className="gen-additional-inputs">
            <h5>Course Details:</h5>
            <div className="gen-additional-inputs-row">
              <div className="gen-left-coursename">
                <div className="thelabel">
                  <h6>Course Name: &nbsp;</h6>
                </div>

                <Select
                  value={desccoursename.label}
                  onChange={(selectedOption) => {
                    setdesccoursename(selectedOption.label); // set selected course
                    setaboutcourse(selectedOption.about); // update course description
                    setselectedgroupobject({
                      value: selectedOption.icongroupid,
                      label: selectedOption.name,
                    }); // update group object
                  }}
                  options={courseOptions}
                />
              </div>
              <div className="abcd">
                <div className="gen-left-issuedon">
                  <div className="thelabel">
                    <h6>Issued Date: &nbsp;</h6>
                  </div>
                  <div className="gen-issuedate-input">
                    <input
                      type="date"
                      value={dateValue}
                      onChange={onDateChange}
                      placeholder="dd-mm-yyyy"
                    />
                  </div>
                </div>

                <div className="certificateid-selectbox">
                  <div className="thelabel">
                    <h6>Select Program: &nbsp;</h6>
                  </div>

                  <Select
                    value={program}
                    onChange={setprogram}
                    options={constants.Programs}
                  />
                </div>
              </div>
              <div className="groupselect-section">
                <div className="thelabel">
                  <h6>Icon Group: &nbsp;</h6>
                </div>
                <div className="selectbox">
                  {selectedgroupobject
                    ? selectedgroupobject.label
                    : "No group selected"}
                </div>
              </div>
            </div>
          </div>

          {!saveandcontinue && (
            <>
              <Button
                label={"Continue"}
                onclick={() => handlesaveandcontinue(true)}
                classname={"saveandcontinue"}
              />
            </>
          )}
        </div>
      </div>

      {saveandcontinue && (
        <>
          <div className="gen-student-upload-section">
            <hr />
            <div className="issue-mode-selection">
              <h3>Certificate Issue Mode</h3>
              <div className="radio-options">
                <label>
                  <input
                    type="radio"
                    name="issuemode"
                    value="single"
                    checked={issueMode === "single"}
                    onChange={() => setIssueMode("single")}
                  />{" "}
                  Single Student
                </label>
                <label style={{ marginLeft: "20px" }}>
                  <input
                    type="radio"
                    name="issuemode"
                    value="multiple"
                    checked={issueMode === "multiple"}
                    onChange={() => setIssueMode("multiple")}
                  />{" "}
                  Multiple Students (via CSV)
                </label>
              </div>
            </div>

            {issueMode === "single" ? (
              <>
                <h3>Enter Student Details</h3>
                <div className="single-student-form">
                  <div className="input-field">
                    <label>Student Name:</label>
                    <input
                      type="text"
                      name="name"
                      value={singleStudent.name}
                      onChange={handleSingleInput}
                      placeholder="Enter full name"
                    />
                  </div>
                  <div className="input-field">
                    <label>Email:</label>
                    <input
                      type="email"
                      name="email"
                      value={singleStudent.email}
                      onChange={handleSingleInput}
                      placeholder="Enter student email"
                    />
                  </div>
                  <div className="input-field">
                    <label>Phone No:</label>
                    <input
                      type="text"
                      name="phone"
                      value={singleStudent.phone}
                      onChange={handleSingleInput}
                      placeholder="Enter phone number"
                    />
                  </div>

                  <div className="email-placeholder">
                    Placeholders $na$ for candidate name, $cn$ for course name,
                    $ce$ for certificate link and $li$ for LinkedIn link.
                  </div>

                  <div className="email-rte">
                    <Rte />
                  </div>

                  <div className="addcertificatediv">
                    <Button
                      onclick={() => handleUploadSingleStudent()}
                      classname={"addandissuecertificate"}
                      disabled={false}
                      label={"Add and Issue Certificate"}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <h4>
                  Upload Student list via CSV (Name, Email, Phone No)
                  <span style={{ marginLeft: "20px" }}>
                    <MuiButton
                      variant="contained"
                      color="primary"
                      startIcon={<CloudDownloadIcon />}
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href =
                          "https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/Certificate/student-upload.csv";
                        link.setAttribute("download", "student-upload.csv");
                        link.target = "_blank";
                        link.click();
                      }}
                      sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        fontWeight: 600,
                        backgroundColor: "#0E73F6",
                        ":hover": { backgroundColor: "#095AD2" },
                      }}
                    >
                      Download Template
                    </MuiButton>
                  </span>
                </h4>

                <Studentupload />

                <hr />

                <div className="email-placeholder">
                  {showcsvdata && (
                    <>
                      <div className="csv-file-data-section">
                        <Csvdata />
                      </div>

                      <div className="email-placeholder">
                        Placeholders $na$ for candidate name, $cn$ for course
                        name, $ce$ for certificate link and $li$ for LinkedIn
                        link.
                      </div>

                      <div className="email-rte">
                        <Rte />
                      </div>

                      <div className="addcertificatediv">
                        <Button
                          onclick={() => handleUploadUserfile()}
                          classname={"addandissuecertificate"}
                          disabled={false}
                          label={"Add and Issue Certificate"}
                        />
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Createandgen;
